// Reference pitch table per spec §4.2.5, with A4 configurable at runtime.

export interface StringTuning {
  open: number;
  positions: Record<number, number>;
}

export const VIOLIN_STRINGS = {
  G3: { open: 196.0, positions: { 1: 220.0, 2: 246.94, 3: 261.63, 4: 293.66, 5: 329.63, 6: 349.23, 7: 392.0 } },
  D4: { open: 293.66, positions: { 1: 329.63, 2: 369.99, 3: 392.0, 4: 440.0, 5: 493.88, 6: 523.25, 7: 587.33 } },
  A4: { open: 440.0, positions: { 1: 493.88, 2: 554.37, 3: 587.33, 4: 659.25, 5: 739.99, 6: 783.99, 7: 880.0 } },
  E5: { open: 659.25, positions: { 1: 739.99, 2: 830.61, 3: 880.0, 4: 987.77, 5: 1108.73, 6: 1174.66, 7: 1318.51 } },
} as const;

export const STRING_NAMES = ['G', 'D', 'A', 'E'] as const;
export const OPEN_STRING_MIDI = [55, 62, 69, 76] as const; // G3, D4, A4, E5

// Recompute open-string frequencies for a custom A4 (default 440).
export function openStringFrequencies(A4 = 440): [number, number, number, number] {
  // Equal temperament semitone ratio; A4 is reference.
  const ratio = (semitones: number) => A4 * Math.pow(2, semitones / 12);
  // G3 = A4 - 14 semitones, D4 = A4 - 7, A4 = A4, E5 = A4 + 7
  return [ratio(-14), ratio(-7), ratio(0), ratio(7)];
}
